import { useWeightMeasurementSystemContext } from '../../contexts/WeightMeasurementUnitsContext';

export const LabelWeight = ({ label, metricBase }) => {
  const { units } = useWeightMeasurementSystemContext(metricBase);

  return `${label} (${units})`;
};
